import { render, staticRenderFns } from "./weekSteps.vue?vue&type=template&id=67f3b18b"
import script from "./weekSteps.vue?vue&type=script&lang=js"
export * from "./weekSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports